import { Bar, BarChart, Cell, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { LTV_CAC } from "./exampleData";
import {
  ACCENT,
  BORDER,
  MUTED,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import ChartCard from "./ChartCard";

/**
 * Lifetime value vs acquisition cost. The 3:1 gap is the headline a founder
 * should take away.
 */
const LtvCacChart = () => (
  <ChartCard
    title="LTV vs CAC"
    caption="A $6,000 lifetime value against a $2,000 acquisition cost is a 3:1 ratio — the benchmark many SaaS businesses aim for to balance growth with profitability."
    height={240}
  >
    <BarChart data={LTV_CAC} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number, _name, item) => [
          formatCurrency(value),
          (item?.payload as { label: string }).label,
        ]}
      />
      <Bar dataKey="value" radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCurrency(v)}
          fontSize={12}
          fill={MUTED_FG}
        />
        {LTV_CAC.map((row) => (
          <Cell key={row.label} fill={row.kind === "ltv" ? ACCENT : MUTED} />
        ))}
      </Bar>
    </BarChart>
  </ChartCard>
);

export default LtvCacChart;
